import { Children, isValidElement, useEffect, useMemo } from 'react'
import React from 'react'
import { Icon, type TIconProps } from '~/components/icon'
import {
  InputMultiSelect,
  useInputMultiSelectContext,
} from '../../input-multi-select'
import type {
  InputMultiSelectActionsProps,
  InputMultiSelectScopedProps,
} from '../../input-multi-select.types'
import { renderCompositionChildren } from '../../utils/render-composition-children'
import { InputMultiSelectActionsVariants } from './index.styles'

export const InputMultiSelectActions = ({
  children,
  __scopeInputMultiSelect,
  ...props
}: InputMultiSelectScopedProps<InputMultiSelectActionsProps>) => {
  const { disabled, hasError, size, readonly, isActive, setActive } =
    useInputMultiSelectContext(
      'InputMultiSelectActions',
      __scopeInputMultiSelect
    )
  const filled = !!(
    props.selectedItemsQuantity && props.selectedItemsQuantity > 0
  )
  const hasTwoItems = !!(
    props.selectedItemsQuantity && props.selectedItemsQuantity > 1
  )

  const iconColor = useMemo((): TIconProps['color'] => {
    if (readonly) return 'colorTextNeutralReadonly'
    return disabled ? 'colorTextNeutralDisabled' : 'colorTextNeutralDefault'
  }, [disabled, readonly])

  useEffect(() => {
    setActive(!!props.isActive)
  }, [props.isActive])

  return (
    <button
      {...props}
      onClick={e => {
        setActive(!isActive)
        if (props.onClick) props.onClick(e)
      }}
      className={InputMultiSelectActionsVariants({
        active: isActive || props.isActive,
        size,
        disabled,
        hasError,
        readonly,
        filled,
        hasTwoItems,
      })}
      aria-disabled={disabled}
    >
      {renderCompositionChildren(
        Children.map(children, child => {
          if (isValidElement(child) && child.type === Icon) {
            return React.cloneElement(child as React.ReactElement<TIconProps>, {
              color: iconColor,
            })
          }
          return child
        }),
        [
          { child: InputMultiSelect.Icon, amount: 1 },
          { child: InputMultiSelect.Field, amount: 1 },
          { child: InputMultiSelect.Quantity, amount: 4 },
          { child: InputMultiSelect.ClearButton, amount: 1 },
          { child: Icon, amount: 1 },
        ]
      )}
    </button>
  )
}
